import {
  withTranslation,
} from 'react-i18next';

import ChampionshipResultTableRaceFieldsView from './ChampionshipResultTableRaceFieldsView';

const TranslatedComponent = withTranslation()(ChampionshipResultTableRaceFieldsView);

const Component = TranslatedComponent;

export default Component;
